import { SvgIcon } from '@mui/material';

export function ChevronLeftSmallIcon(props) {
	return (
		<SvgIcon width="6" height="8" viewBox="0 0 6 8" fill="none" {...props}>
			<path
				d="M4.5 1L1.5 3.98096L4.5 7"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
			/>
		</SvgIcon>
	);
}
